import Alt from 'alt';
import root from 'window-or-global';

/**
 * Setup alt and wrap it in debugger.
 *
 * Alt is a singleton on the root window and on the server in the global scope.  this means that we need
 * to make sure that we only ever use a single instance.
 *
 * Requires this chrome extension:
 * https://github.com/goatslacker/alt-devtool
 */
let alt; //eslint-disable-line
if (typeof root['__epic-react-common-alt'] !== 'undefined') {
    alt = root['__epic-react-common-alt'];
} else {
    alt = new Alt({
        // Hack for alt so that server-side we don't always have to flip to a string and back.  Our objects are already JSON
        // Data on the server, so just return that.
        deserialize(data) {
            if (typeof data === 'string') {
                return JSON.parse(data);
            }
            return data;
        }
    });
    root['__epic-react-common-alt'] = alt;
}
export default alt;



// WEBPACK FOOTER //
// ../epic-react-common/src/alt.js